//
//
//
//
//
//
//
//
//


import { mapGetters, mapActions } from 'vuex'
import Footer from '../components/footer/Footer.vue'
import Header from '../components/header/Header.vue'
import CartItemAddedModal from '~/components/cart/CartItemAddedModal'

export default {
  components: {
    Header,
    Footer,
    CartItemAddedModal
  },
  computed: {
    ...mapGetters(['currentUser', 'seoName']),
    metaTitle () {
      return 'Pizza Delivery, Takeaway And Deals In ' + this.seoName + ' | Order Online With Tops Pizza'
    },
    metaDescription () {
      return 'Great Tasting, Great Value And Great Service. Pizza And More Delivered To Your Door In ' + this.seoName + '; Order Online For Fast Delivery.'
    }
  },
  created () {
    if (process.client && this.currentUser) {
      this.getLoyalty()
    }
  },
  methods: {
    ...mapActions(['getLoyalty'])
  },
  head () {
    return {
      title: this.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDescription
        }
      ]
    }
  }
}
